<template>
  <main class="form-page">
    <v-toolbar flat color="white" class="mb-4">
      <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
    </v-toolbar>
    <v-container>
      <v-col cols="12" v-if="$route.params.slug">
        <locale-select @change="fireLocaleChange" />
      </v-col>
      <form-wrapper :validator="$v.form">
        <form @submit.prevent="handleSubmit">
          <!-- main info componennt -->
          <MainInfo :form="form" />
          <!-- main info componennt -->

          <v-card>
            <v-card-title>{{ $t("heading.media") }}</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="6">
                  <v-subheader>logo</v-subheader>
                  <new-image-upload
                    class="file-upload__image"
                    :imgUrl="form.logo ? form.logo.path : ''"
                    :resetToggle="resetImage"
                    @fileSelected="handleselectLogo"
                    :maxSize="logoSize"
                    :imgId="form.logo ? form.logo.id : null"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-col cols="12">
            <v-btn
              type="submit"
              class="primary"
              :disabled="$v.form.$invalid"
              :loading="btnLoading"
              >{{ $t("button.save") }}</v-btn
            >
          </v-col>
        </form>
      </form-wrapper>
    </v-container>
  </main>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  numeric,
  url
} from "vuelidate/lib/validators";
import { StoreData, ShowData, UpdateData } from "@/helpers/apiMethods";
import Cookies from "js-cookie";

export default {
  name: "CreateAndEdit",
  components: {
    MainInfo: () => import("./components/MainInfo")
  },
  provide() {
    return {
      $v: this.$v
    };
  },
  data() {
    return {
      form: {
        name: "",
        url: "",
        priority: "",
        logo: ""
      },
      logoSize: 1.24,
      resetImage: false,
      btnLoading: false,
      logoChange: false,
      mainMediaChanged: false,
      multiImageChanged: false,
      locale: Cookies.get("language")
    };
  },
  mounted() {
    this.showWorkData();
  },
  methods: {
    fireLocaleChange(locale) {
      this.locale = locale;
      this.showWorkData();
    },
    showWorkData() {
      const { slug } = this.$route.params;
      if (this.$route.name === "edit_client") {
        ShowData({ reqName: "clients", id: slug, locale: this.locale })
          .then(res => {
            const { client } = res.data;
            this.form = client;
          })
          .catch(err => console.log(err));
      }
    },
    resetData() {
      this.$v.form.$reset();
      this.form = {};
    },
    handleSubmit() {
      this.btnLoading = true;
      if (this.$route.name === "create_client") {
        // in case create
        this.createWork();
      } else {
        // in case update
        this.updateWork();
      }
    },
    handleselectLogo(photo) {
      this.form.logo = photo.file;
      this.logoChange = true;
    },
    buildData() {
      const formData = new FormData();
      formData.append("name", this.form.name);
      this.form.url ? formData.append("url", this.form.url) : "";
      formData.append("priority", this.form.priority);
      this.checkLogo(this.form.logo)
        ? formData.append("logo", this.form.logo)
        : "";

      if (this.$route.name === "edit_client") {
        formData.append("locale", this.locale);
        formData.append("_method", "put");
      }

      return formData;
    },
    createWork() {
      const formData = this.buildData();
      StoreData({ reqName: "clients", data: formData })
        .then(() => {
          this.$router.go(-1);
        })
        .catch(err => console.log(err))
        .finally(() => {
          this.btnLoading = false;
        });
    },
    updateWork() {
      const formData = this.buildData();
      UpdateData({
        reqName: "clients",
        data: formData,
        id: this.$route.params.slug
      })
        .then(() => {
          this.$router.go(-1);
          this.videoChanged = false;
        })
        .catch(err => console.log(err))
        .finally(() => {
          this.btnLoading = false;
        });
    },
    checkLogo(logo) {
      return logo instanceof File;
    }
  },
  validations() {
    return {
      form: {
        name: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(150)
        },
        priority: {
          required,
          numeric
        },
        logo: {
          required
        },
        url: {
          url
        }
      }
    };
  },
  computed: {
    formTitle() {
      if (this.$route.name === "create_client") {
        return this.$t("heading.create");
      } else {
        return this.$t("heading.edit");
      }
    }
  },
  watch: {
    form: {
      handler(form) {
        this.form = form;
      },
      immediate: true
    }
  }
};
</script>
